module.exports = __webpack_public_path__ + "static/home-fd206fc145007ae0a593cb3ae2e0673f.webm";